<h1 mat-dialog-title>
    <app-titulo-paginas [titulo]="data.tipo"></app-titulo-paginas>
</h1>
<mat-dialog-content>
    <h2>{{data?.titulo}}</h2>
    <p>{{data?.conteudo}}</p>
    <a [href]="data?.link">{{data?.link}}</a>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="dialogRef.close()">Fechar</button>
</mat-dialog-actions>